import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {toast} from 'react-toastify';
import { getPathwayConfigurationById } from '@app/services/learningPathway';
import { useSelector } from 'react-redux';
import PreviewWorksheetsPDF from './PreviewWorksheetsPDF';
import { getAllActiveFranchise } from '@app/services/franchise';
import { useDecodedParam } from '@app/hooks/useDecodedParam';
import { Button } from "@app/components";

const ViewPathwayDetails = () => {
    let obj: any = {}
    const [pathwayDetails, setPathwayDetails] = useState(obj);
    const [previewModuleId, setPreviewModuleId] = useState('');
    const id = useDecodedParam('id', '/learning-pathway');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const canAccess = useSelector((state: any) => state.auth.permissions['learning-pathway']);
    const [wsPreview, setWsPreview] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getAllActiveFranchiseData()
        getPathwayConfigurationByIdAPI(id);

        return () => {
            // Anything in here is fired on component unmount.
            // setPreviewModuleId('')
        }
    },[]);

    const getPathwayConfigurationByIdAPI = async (id) => {
        try {
            const resp = await getPathwayConfigurationById(id);
            if (resp?.success === true) {
                setPathwayDetails(resp?.collections);
            } else {
                navigate('/learning-pathway');
                toast.error('Something went wrong!');
                // toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getAllActiveFranchiseData = async () => {
        try {
            const resp = await getAllActiveFranchise();
            if (resp?.success === true) {
                if (resp?.collections.some(e => e.student_local_printing == true)) {
                    setWsPreview(true)
                }
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    return (
        <div>
            {/* Content Header (Page header) */}
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Learning Pathway Details</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/learning-pathway">Learning Pathways</a></li>
                                <li className="breadcrumb-item active"> Learning Pathway Details</li>
                            </ol>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
            </section>
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div style={{ marginBottom: 10 }} className="row">
                                
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Learning Pathway Details </h3>
                                    <div className="col-lg-12 text-right">
                                        <Button className="btn btn-default mr-2" onClick={() => navigate(-1)}>Back</Button>
                                        {/* <Link className="btn btn-primary" to={ `/learning-pathway/edit/${id}`} > Edit </Link> */}
                                    </div>
                                </div>
                                {/* /.card-header */}
                                <div className="card-body">
                                     <div className='row'>
                                        <div className='col-sm-3'>
                                            <dt>Pathway Name</dt>
                                            <dd>{ pathwayDetails?.name ?? '---' }</dd>
                                        </div>
                                        <div className='col-sm-3'>
                                            <dt>Franchise</dt>
                                            <dd>{ pathwayDetails?.franchise_id !== 0 ? pathwayDetails?.franchise_name : 'FCL Default' }</dd>
                                        </div>
                                        <div className='col-sm-3'>
                                            <dt>Subject</dt>
                                            <dd>{ pathwayDetails?.subject_name ?? '---' }</dd>
                                        </div>
                                        <div className='col-sm-3'>
                                            <dt>Status</dt>
                                            <dd>{ pathwayDetails?.status ? pathwayDetails?.status.charAt(0).toUpperCase() + pathwayDetails?.status.slice(1) : '---' }</dd>
                                        </div>
                                    </div>
                                    <hr/>
                                    <table className="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Module Name</th>
                                                <th>Worksheet Range</th>
                                                <th>Type</th>
                                                <th>Description </th>
                                                { canAccess?.['worksheet-preview'] && wsPreview &&
                                                    <th className='text-center'>Worksheet Preview</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { pathwayDetails?.pathway && pathwayDetails?.pathway.map((module, i) => (
                                                <tr key={i}>
                                                    <td> { module?.name }</td>
                                                    <td> { module?.worksheet_from + ' - ' + module?.worksheet_to }</td>
                                                    <td> { module?.type ? module?.type.charAt(0).toUpperCase() + module?.type.slice(1) : '---' } </td>
                                                    <td style={{ maxWidth: '200px' }} className='text-truncate'> { module?.description ? module?.description : '---' } </td>
                                                    { canAccess?.['worksheet-preview'] && wsPreview &&
                                                        <td className='text-center'>  
                                                            <a  href="#"
                                                                data-toggle="tooltip" title="Worksheet Preview"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    setPreviewModuleId(module?.id)
                                                                    handleShow()
                                                                }}
                                                            ><i className="fas fa-eye mr-2"/></a>
                                                        </td>
                                                    }
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                                {/* /.card-body */}
                            </div>
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container-fluid */}
            </section>
            {/* /.content */}
            <PreviewWorksheetsPDF
                moduleId={previewModuleId}
                show={show}
                handleClose={handleClose}
            />
        </div>
    )
}

export default ViewPathwayDetails